module.exports = __webpack_public_path__ + "static/media/gallery-img-12.c1594ae3.jpg";